import React from 'react';
import {
    hashHistory,
} from 'react-router';
import {
    Layout,
    Menu,
    Dropdown,
    Spin,
    Modal,
    Select,
    message,
    Carousel,
    Button,
    Radio
} from 'antd';
import Menus from './components/Menus';
import {
    logout,
    getNoMessageCount,
    fetchAllChannelList,
    changOrg, fetchAllBusinessLineList,
} from './service/home';
// import {
//   getMessageList,
//   getOrderCount,
// } from '../service/mall';
import {list} from './service/channelFunc';
import {config, CookieUtils} from 'Utils';
import myObject from './utils/signals';
import './App.css';
import kf from './assets/images/kf.png'; //在线客服
import xiaZaiAppCs from './assets/images/ceShiXiaZaiApp.png'; //测试环境
import xiaZaiApp from './assets/images/xiaZaiApp.png';
import {red, white} from "mockjs/src/mock/random/color_dict";
import setLanguageText from "./utils/languageSet"; //生产环境
const imgData = {
    'photoImgLeft': require('./assets/images/ico_8a.png'),
    'photoImgRight': require('./assets/images/ico_8.png'),
};
const {Header, Sider, Content} = Layout;

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            user: {},
            saveFlag: false,
            haveMessage: 0,
            channelList: [],
            businessLineList: [],
            siderVisibile: true,
            // left: './assets/images/ico_8.png',
            // right: './assets/images/ico_8a.png',
            leftOrRight: './assets/images/ico_8a.png',
            // channelName: ''
            channelName: window.sessionStorage.getItem('cur_channelName'),
            businessLineName: window.sessionStorage.getItem('cur_businessName'),
            rows: [],
            total: '',
            loading: false,
            searchObj: {
                title: '',
                isShow: '',
                type: '',
                startDate: '',
                endDate: '',
                isPublish: '1',
                p: 1,
                s: 5,
            },
            zIndex: '-1',
            orderLength: 0,
            messageLength: 0,
            visible: false,
            languageSet: {},
            language: CookieUtils.get('language') || "zh",
            ouId: window.sessionStorage.getItem('cur_ouId'),
            ouName: window.sessionStorage.getItem('cur_ouName'),
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}')
        };
        this.toggle = this.toggle.bind(this);
        this.resize = this.resize.bind(this);
        this.clickHandle = this.clickHandle.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.getOrderLength = this.getOrderLength.bind(this);
        this.getMessageLength = this.getMessageLength.bind(this);
        this.timer = this.timer.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
        setLanguageText("app", this);
        window.onresize = this.resize;
        window.document.body.onload = this.resize;
        var self = this;
        let userData = self.state.userData;
        this.setState({
            'user': userData,
        });
        document.addEventListener('showSpin', self.show, false);
        document.addEventListener('hideSpin', self.hide, false);
        getNoMessageCount().then((result) => {
            if (result && result.code == 200) {
                sessionStorage.setItem('not_message_count', result.data.message);
                self.setState({
                    'haveMessage': result.data.message,
                });
            }
        });
        // if (window.sessionStorage.getItem('channel_list')) {
        //     this.setState({
        //         channelList: JSON.parse(window.sessionStorage.getItem('channel_list')),
        //     });
        // } else {
        fetchAllChannelList().then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    channelList: result.data,
                });
            } else {
                message.error(result.message);
            }
        });

        fetchAllBusinessLineList().then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    businessLineList: result.data
                });
            } else {
                message.error(result.message);
            }
        });
        //}
        this.interval = setInterval(() => this.tick(), 2000);
    }

    tick = () => {
        this.setState({zIndex: '1000'});
        clearInterval(this.interval);
    };

    componentWillMount() {
        //咨询客服插件
        // let script = document.createElement('script');
        // script.type = 'text/javascript';
        // script.src = 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=4208aa20-a416-11e8-ba0f-1960c9d1906b&autoShow=false&language=ZHCN';
        // script.async = true;
        // document.body.appendChild(script);
        if (this.state.language == "zh") {
            this.getData();
        }
    }

    componentWillUnmount() {
        myObject.channelSignal.remove(this.onChannelSignal);
        window.onresize = null;
        window.document.body.onload = null;
        window.clearInterval(this.interval);
        document.removeEventListener('changeOrderLength', this.getOrderLength);
        document.removeEventListener('loginInfoChange', this.loginInfoChangeHandle);
    }

    show() {
        this.setState({
            saveFlag: true,
        });
    }

    hide() {
        this.setState({
            saveFlag: false,
        });
    }

    onChannelSignal = (channelName) => {
        this.setState({
            channelName: channelName,
        });
    };

    getData() {
        this.setState({loading: true});
        list(this.state.searchObj).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    rows: result.data,
                    total: result.total,
                    loading: false,
                });
            } else {
                message.error(result.message);
                this.setState({loading: false});
            }
        });
    }

    resize() {
        if (document.body.clientWidth < 1680) {
            this.setState({collapsed: true});
        } else {
            this.setState({collapsed: false});
        }
    }

    toMessage() {
        hashHistory.push('/message');
    }

    toProfile() {
        hashHistory.push('/profile');
    }

    toggle() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    clickHandle({item, key, keyPath}) {
        if (key === 'logout') {
            logout().then(result => {
                window.localStorage.removeItem("session_token");
                hashHistory.push('/');
            });
        } else if (key === 'profile') {
            this.toProfile();
        }
    }

    handleChange = (value) => {
        this.setState({channelName: value});
        let val = value.split('|')[1];
        let userData = this.state.userData;
        if (userData.roleCode == "cpxx") {
            window.location.href = '#mallHome';
        } else if (userData.roleCode == "overseas") {
            window.location.href = '#productEn';
        } else if (userData.roleCode == "overseasCust") {
            window.location.href = '#productEn';
        } else {
            window.location.href = '#/home';
        }
        window.location.reload();
        window.sessionStorage.setItem('cur_channel', value);
        window.sessionStorage.setItem('cur_channelId', val);
    };

    qimoChatClick = () => {
        this.qimoChatClick();
    }

    showDownCode = () => {
        Modal.info({
            title: this.state.languageSet.tip1,
            content: (
                <div>
                    {/*<img width="100%" style={{marginLeft:'-5%',marginTop:'5%'}} height="auto" alt="" src={require('./assets/images/ceShiXiaZaiApp.png')} />测试*/}
                    <img width="100%" style={{marginLeft: '-5%', marginTop: '5%'}} height="auto" alt=""
                         src={config.index == 1 ? xiaZaiApp : xiaZaiAppCs}/>
                </div>
            ),
            onOk() {
            },
        });
    };

    changeSider = () => {
        var siderVisibile = this.state.siderVisibile;
        var leftOrRight = this.state.leftOrRight;
        var collapsed = this.state.collapsed;
        if (leftOrRight == './assets/images/ico_8a.png') {
            leftOrRight = './assets/images/ico_8.png';
        }
        if (leftOrRight == './assets/images/ico_8.png') {
            leftOrRight = './assets/images/ico_8a.png';
        }
        // console.log(siderVisibile)
        this.setState({
            //siderVisibile: !siderVisibile,
            collapsed: !collapsed,
            leftOrRight: leftOrRight,
        });
    };

    onCollapse = (collapsed) => {
        this.setState({collapsed});
    };

    /****************** 商城功能 **********************/

    /*获取订单数量*/
    getOrderLength() {
        /*getOrderCount().then(res => {
         if (res.status) {
         this.setState({
         orderLength: res.data.mineCount || 0,
         });
         } else {
         message.error(res.message);
         }
         });*/
        this.setState({
            orderLength: 0,
        });
    }

    /*获取消息*/
    getMessageLength() {
        /*getMessageList({ source: 3 }).then(res => {
         if (res.status) {
         this.setState({
         messageLength: res.data.message || 0,
         });
         } else {
         message.error(res.message);
         }
         });*/
        this.setState({
            messageLength: 0,
        });
    }

    /*定时器*/
    timer() {
        var self = this;
        self.interval = window.setInterval(function () {
            self.getMessageLength();
        }, 60000);
    }

    toggleHome() {
        let url = window.location.href;
        if (/dms-pc/.test(url)) {
            window.location.href = url.split('dms-pc')[0] + 'dms-pc/#/home';
        } else {
            window.location.href = '/#/home';
        }
    }

    onChannelCancel = (e) => {
        this.setState({
            visible: false
        });
    }

    ouOnChange = (e) => {
        this.setState({
            ouId: e.target.value,
            ouName: e.target['data-name']
        });
    }

    onChange = (e) => {

        changOrg({
            orgId: this.state.ouId,
            channelCode: 'FX',
            businessLine: e.target['data-id']
        }).then(result => {
            if (result.status && result.status == true) {
                this.setState({
                    channelName: '全局',
                    channelCode: 'FX',
                    businessLineName: e.target.value,
                    businessLineCode: e.target['data-id'],
                    visible: false
                });
                let userData = this.state.userData;
                if (userData.roleCode == "cpxx") {
                    window.location.href = '#mallHome';
                } else if (userData.roleCode == "overseas") {
                    window.location.href = '#productEn';
                } else if (userData.roleCode == "overseasCust") {
                    window.location.href = '#productEn';
                } else {
                    window.location.href = '#/home';
                }
                window.location.reload();
                var _data = e.target.value + '|' + e.target['data-id'];
                //window.sessionStorage.setItem('channel_list', JSON.stringify(this.state.channelList));
                window.sessionStorage.setItem('cur_ouId', this.state.ouId);
                window.sessionStorage.setItem('cur_ouName', this.state.ouName);
                window.sessionStorage.setItem('cur_channelName', '全局');
                window.sessionStorage.setItem('cur_channel', '全局|FX');
                window.sessionStorage.setItem('cur_channelId', 'FX');
                window.sessionStorage.setItem('cur_businessName', e.target.value);
                window.sessionStorage.setItem('cur_business', _data);
                window.sessionStorage.setItem('cur_businessId', e.target['data-id']);
            } else {
                message.error(result.message);
            }
        });
    }

    onClick() {
        this.setState({
            visible: true
        });
    }

    /****************** 商城功能 end ******************/

    render() {
        const {routes} = this.props;
        const {
            channelName, rows, zIndex,
            orderLength, messageLength, visible, ouName, businessLineName
        } = this.state;
        const RadioGroup = Radio.Group;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
            marginLeft: '35px',
            fontSize: '17px'
        };
        const isMall = /^\/mall\S*/.test(this.props.location.pathname);
        let info = (rows || []).map(function (ele, index) {
            return <div key={index}><a style={{color: 'white'}} href={`#/channelFunc/${ele.id}`}>{ele.title}</a></div>;
        });
        let last = routes[routes.length - 1];
        let path = last.path ? last.path : routes[routes.length - 2]['path'];
        path = path === '/' ? '' : path;
        const menu = (
            <Menu onClick={this.clickHandle}>
                <Menu.Item key="profile">{this.state.languageSet.profile}</Menu.Item>
                <Menu.Item key="logout">{this.state.languageSet.logout}</Menu.Item>
            </Menu>
        );
        let haveMessageFn = function (key) {
            if (key) {
                return <span></span>;
            } else {
                return '';
            }
        };
        const channelMapper = (item, index) => {
            return <Select.Option key={'s_' + index} value={item.name + '|' + item.code}>{item.name}</Select.Option>;
        };

        const radioChannelMapper = (item, index) => {
            if (item.orgIds.indexOf(this.state.ouId) >= 0) {
                return <Radio key={'radio_' + index} data-id={item.code} style={radioStyle}
                              value={item.name}>{item.name}</Radio>;
            }
        };

        // var currentChannel = channelName ? channelName.split('|')[0] : window.sessionStorage.getItem('cur_channel') ? window.sessionStorage.getItem('cur_channel').split('|')[0] : '';
        return (
            <Spin
                spinning={this.state.saveFlag} tip="保存中，请等待..." size='large'>
                <Layout className="dms-app" style={{position: 'relative'}}>
                    {/* 客服 */}
                    {/*<img*/}
                    {/*onClick={this.qimoChatClick()}*/}
                    {/*style={{*/}
                    {/*position: 'absolute',*/}
                    {/*width: '42px',*/}
                    {/*height: '145px',*/}
                    {/*zIndex: 10,*/}
                    {/*bottom: '40px',*/}
                    {/*}}*/}
                    {/*src={kf}/>*/}
                    {/* 菜单 */}
                    <Sider
                        collapsible
                        collapsed={this.state.collapsed}
                        onCollapse={this.onCollapse}
                        defaultCollapsed={true}
                        style={{display: this.state.siderVisibile == false ? 'none' : 'block', background: '#EFEFEF'}}
                    >
                        <div className="logo">
                            <img width="50%" height="auto" alt="产品logo"
                                 src={require('./assets/images/logo-web.png')}/>
                        </div>
                        <Menus collapsed={this.state.collapsed} defaultSelectedKeys={path ? [path] : []}
                               routes={this.props.routes}/>
                    </Sider>

                    <Modal
                        visible={visible}
                        title={this.state.languageSet.businessLine}
                        footer={null}
                        closable={false}
                        maskClosable={false}
                        width={400}
                        onCancel={this.onChannelCancel}
                    >
                        <div style={{marginBottom: '20px'}}>
                            <RadioGroup onChange={this.ouOnChange} value={this.state.ouId}>
                                <Radio key='ouradio_1' data-name={this.state.languageSet.gfcompany} style={radioStyle}
                                       value={'82'}
                                >{this.state.languageSet.gfcompany}</Radio>
                                <Radio key='ouradio_2' data-name={this.state.languageSet.tyxcompany} style={radioStyle}
                                       value={'86'}
                                >{this.state.languageSet.tyxcompany}</Radio>
                            </RadioGroup>
                        </div>
                        <hr style={{height: 1}}/>
                        <div style={{marginBottom: '20px', marginTop: '20px'}}>
                            <RadioGroup onChange={this.onChange}>
                                {
                                    this.state.businessLineList.map(radioChannelMapper)
                                }
                            </RadioGroup>
                        </div>
                        <hr style={{height: 1}}/>
                        <div>{this.state.languageSet.tip}</div>
                    </Modal>

                    <Layout className="dms-main">
                        <Header>
                            <div style={{float: 'left'}}>
                                <span style={{color: '#fff'}}>{ouName}：{businessLineName}</span>
                                <span>&nbsp;</span>
                                <Button type="primary" size={'small'} onClick={this.onClick}
                                        icon='retweet'>{this.state.languageSet.switch}</Button>
                                {/*<Select style={{width: 150}} onChange={this.handleChange}*/}
                                {/*        value={currentChannel}>*/}
                                {/*    {*/}
                                {/*        this.state.channelList.map(channelMapper)*/}
                                {/*    }*/}
                                {/*</Select>*/}
                            </div>
                            <Dropdown overlay={menu} placement="bottomCenter" trigger={['click']}
                                      overlayClassName="dms-user-logout">
                                <div className="login-user">
                                    <img className="dms-user-photo" alt="用户头像"
                                         src={this.state.user.imgUrl ? `${this.state.user.imgUrl}` : require('./assets/images/dms-man02.png')}/>
                                    <span style={{color: '#fff'}}>{this.state.user.userName}</span>
                                </div>
                            </Dropdown>
                            <i className="dmsIcon dmsBell notice-global"
                               onClick={this.toMessage}>{haveMessageFn(this.state.haveMessage)}</i>
                            <i className="anticon anticon-qrcode" title="二维码在这" style={{
                                float: 'right',
                                fontSize: 30,
                                marginRight: 10,
                                color: '#858585',
                                marginTop: 6,
                                cursor: 'pointer',
                            }} onClick={this.showDownCode}></i>
                        </Header>
                        <div style={{
                            background: 'none',
                            position: 'absolute',
                            zIndex: zIndex,
                            width: '35%',
                            marginLeft: '25%',
                        }}>
                            <Carousel autoplaySpeed={10000} autoplay={true} dots={false}>
                                {info}
                            </Carousel>
                        </div>
                        <a
                            style={{
                                background: 'none', position: 'absolute', top: '45.7%',
                                zIndex: '1000', height: '10%', /*border:'1px solid #777',*/
                                textIndent: '0', opacity: 1,
                                width: '0px', padding: '0px', borderRadius: 'none',
                            }}
                            className='buttonOpen'
                            onClick={this.changeSider.bind(this)}>
                            &nbsp;
                        </a>
                        <Content className="dms-content">
                            {!isMall && this.props.children}
                            {isMall &&
                                <div style={{minHeight: this.state.mainHeight, background: '#fff'}}
                                     className="dms-content">
                                    {this.props.children}
                                </div>}
                        </Content>
                    </Layout>
                </Layout>
            </Spin>

        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js